import { Link } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { database } from "../firebase";
import { DotLoader } from "react-spinners";
import { useParams } from "react-router-dom";
import moment from "moment";
const { forwardRef, useRef, useImperativeHandle } = React;


const EditMusic = forwardRef((props, ref) => {
    let { id } = useParams();
    const [accepted, setAccepted] = useState([]);
    const [loading, setLoading] = useState(false);
    const [category_check_list, setCategoryCheckList] = useState([]);
    const [active_check_list, setActiveCheckList] = useState([])
    const { currentUser } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
    }));
    function getUserData(uid) {
        return new Promise((resolve, reject) => {
            return database.ref("users/" + uid).once("value", (snap) => {
                resolve(snap.val());
            });
        });
    }

    function getCreditzData(credid) {
        return new Promise((resolve, reject) => {
            return database.ref("creditz/" + credid).once("value", (snap) => {
                resolve(snap.val());
            });
        });
    }
    let userValue = ""
    useEffect(() => {
        if (id === undefined) {
            userValue = currentUser.uid
        }
        else {
            userValue = id
        }

    }, [id])


    const [acceptCheckingList, setacceptCheckingList] = useState([])
    function AcceptedCreditz(dummystate) {
        const user = [];

        setLoading(true);
        database.ref("users/" + userValue).once("value").then(async (snapshot) => {

            user.push(snapshot.val())
        }).then(() => {

            return database
                .ref(`/user-creditz/`)
                .once("value")
                .then(async (snapshot) => {
                    const request = [];
                    let us = [];
                    snapshot.forEach((childSnapshot) => {
                        request.push(Object.values(childSnapshot.val()))
                        us = request.map(req => {
                            return req.find(r => {
                                return r.email === user[0].email;
                            })
                        }).filter((e) => e);
                    });
                    const pendingRequests = [];
                    us.map((req) => {

                        if (req.status === "Accepted ") {
                            pendingRequests.push(req);
                        }
                    })
                        .filter((e) => e);

                    var newRes = await Promise.all(
                        pendingRequests.map(async (user) => {
                            const Data = await getUserData(user.uid);
                            const Creddata = await getCreditzData(user.credid);
                            return {
                                ...user,
                                user_details: Data,
                                Creditz: Creddata,
                            };
                        })
                    );
                    var filterres = newRes
                        .map((music) => {
                            if (music.Creditz?.category == "Music") {
                                return {
                                    ...music,
                                    Creditz: music.Creditz,
                                    user_details: music.user_details,
                                };
                            }
                        })
                        .filter((e) => e);

                    database.ref('/removeCreditz/' + userValue).once("value")
                        .then(async (snapshot) => {
                            let remove = [];

                            remove.push(snapshot.val())
                            if (remove[0]) {
                                const newfilterres = filterres.map((filter) => {
                                    if (!(filter.credid in remove[0])) {
                                        return { key: filter.credid, checked: true }
                                    }
                                    else {
                                        return { ...filter, key: filter.credid, checked: false }
                                    }


                                }).filter((e) => e);
                                setacceptCheckingList(newfilterres)
                            }
                            else {
                                const elsefilterres = filterres.map((filter) => {
                                    return { key: filter.credid, checked: true }


                                }).filter((e) => e);
                                setacceptCheckingList(elsefilterres)
                            }

                        })
                    setAccepted(filterres);
                    setLoading(false);
                });


        })



    }

    const [sent, setSent] = useState([]);
    const [checking, setCHecking] = useState([])

    function GetCreditz() {
        setLoading(true)
        let userValue = ""
        if (id === undefined) {
            userValue = currentUser.uid

        }
        else {
            userValue = id

        }
        return database.ref('/creditz').orderByChild('uid').equalTo(userValue)
            .once("value")
            .then(async (snapshot) => {
                const creditz = [];
                snapshot.forEach((childSnapshot) => {
                    creditz.push({ key: childSnapshot.key, data: childSnapshot.val() });
                });
                var filterres =
                    creditz.map((music) => {
                        if (music.data.category == "Music") {
                            return {
                                ...music,
                                Creditz: music.Creditz,

                            };
                        }
                    })
                        .filter((e) => e);

                database.ref('/removeCreditz/' + userValue).once("value")
                    .then(async (snapshot) => {
                        let remove = [];

                        remove.push(snapshot.val())
                        if (remove[0]) {
                            const newfilterres = filterres.map((filter) => {
                                if (!(filter.key in remove[0])) {
                                    return { key: filter.key, checked: true }
                                }
                                else {
                                    return { ...filter, key: filter.key, checked: false }
                                }


                            }).filter((e) => e);
                            setCHecking(newfilterres)
                        }
                        else {
                            const elsefilterres = filterres.map((filter) => {
                                return { key: filter.key, checked: true }


                            }).filter((e) => e);
                            setCHecking(elsefilterres)
                        }

                    })
                setSent(filterres);

            }

            )
        setLoading(false)
    }


    const categoryCheckboxFilterHandler = (e, i) => {
        if (checking[i].checked == true) {
            checking[i].checked = false
        }
        else {
            checking[i].checked = true
        }

        if (e.target.checked == false) {
            setCategoryCheckList([...category_check_list, e.target.value]);
        }

        else {
            let check_list = [];
            category_check_list.map(check => {
                if (check != e.target.value) {
                    check_list.push(check);
                }
            });
            setCategoryCheckList(check_list);
        }

        if (e.target.checked == true) {

            setActiveCheckList([...active_check_list, e.target.value]);


        }
        else {
            let check_list = [];
            active_check_list.map(check => {
                if (check != e.target.value) {
                    check_list.push(check);
                }
            });
            setActiveCheckList(check_list);

        }

    };

     
    
    const categoryCheckboxFilterHandlers = (e, i) => {

        if (acceptCheckingList[i].checked == true) {
            acceptCheckingList[i].checked = false
        }
        else {
            acceptCheckingList[i].checked = true
        }

        if (e.target.checked == false) {
            setCategoryCheckList([...category_check_list, e.target.value]);
        }

        else {
            let check_list = [];
            category_check_list.map(check => {
                if (check != e.target.value) {
                    check_list.push(check);
                }
            });
            setCategoryCheckList(check_list);
        }

        if (e.target.checked == true) {

            setActiveCheckList([...active_check_list, e.target.value]);


        }
        else {
            let check_list = [];
            active_check_list.map(check => {
                if (check != e.target.value) {
                    check_list.push(check);
                }
            });
            setActiveCheckList(check_list);

        }

    };



    useImperativeHandle(ref, () => ({
        handleUpdate() {
            category_check_list.map(async (check) => {
                await database.ref("removeCreditz/").child(currentUser.uid).child(check).set({
                    isDeleted: 'true'
                });


            }
            )

            active_check_list.map(async (check) => {
                return database.ref("removeCreditz/").child(currentUser.uid).child(check).remove()

            }
            )

        }

    }));

    useEffect(() => {
        AcceptedCreditz();
        GetCreditz();
    }, []);
    return (
        <>
            <div className="row mb-1">
                <div className="col-md-6 col-xl-4 mb-3">
                    <label className="fw-medium">
                        <input className="form-check-input me-2" type="checkbox" defaultChecked />
                        Show/Hide on profile page
                    </label>
                </div>

                <div className="col-md-6 col-xl-4 text-md-end text-xl-center mb-3">
                    {/* <button onClick={() => handleUpdate()}> Check </ button> */}
                    <p className="fw-medium mb-1">Select 12 Featured</p>
                    <p className="mb-0 text-primary">Total {sent.length + accepted.length} Records</p>
                </div>
            </div>
            <div className="table-responsive">
                <table className="table align-middle text-center">
                    <thead className="bg-lightblue-gradient text-primary fw-semibold">
                        <tr>
                            <td className="border-bottom">Select</td>
                            <td className="border-bottom">Title</td>
                            <td className="border-bottom">Artwork</td>
                            <td className="border-bottom">Role</td>
                            <td className="border-bottom">Creator</td>
                            {/* <td className="border-bottom">Creditors</td> */}
                            <td className="border-bottom">Date</td>
                            <td className="border-bottom">Action</td>
                        </tr>
                    </thead>
                    <tbody>
                        {sent &&
                            sent.map((music, index) => (

                                <tr>
                                    <td>
                                        <input className="form-check-input" type="checkbox" checked={checking[index]?.checked} name={music.key} id={music.key} value={music.key} onChange={e => categoryCheckboxFilterHandler(e, index)} />
                                    </td>
                                    <td>{music?.data.trackname}</td>
                                    <td>
                                        <img src={music?.data?.albumImage} className="mmwh-45 rounded
                                 " alt="musician" />
                                    </td>
                                    <td>
                                        <span className="badge px-3 py-2 rounded-pill fw-medium bg-blue">{music?.data?.role}</span>
                                    </td>
                                    <td className="text-primary">{"@" + music?.data?.publishedBy}</td>

                                    <td>{moment(music?.data?.publishedAt).format("DD/MM/YYYY")}</td>
                                    <td>
                                        <Link to={`/viewcreditz/${music?.key}`} className="btn btn-primary btn-sm rounded-pill px-4 fw-semibold">View</Link>
                                    </td>
                                </tr>

                            ))}
                        {accepted &&
                            accepted.map((music, index) => (
                                <tr>
                                    <td>
                                        <input className="form-check-input" type="checkbox" name={music.credid} checked={acceptCheckingList[index]?.checked} id={music.credid} value={music.credid} onChange={e => categoryCheckboxFilterHandlers(e, index)} />
                                    </td>
                                    <td>
                                        {music.Creditz.trackname}

                                    </td>
                                    <td>
                                        <img src={music?.Creditz?.albumImage} className="mmwh-45 rounded
                                 " alt="musician" />
                                    </td>
                                    <td>
                                        <span className="badge px-3 py-2 rounded-pill fw-medium bg-blue">{music?.Creditz?.role}</span>
                                    </td>
                                    <td className="text-primary">{"@" + music?.Creditz?.publishedBy}</td>

                                    <td>

                                        {moment(music?.Creditz?.publishedAt).format("DD/MM/YYYY")}
                                    </td>
                                    <td>

                                        <Link to={`/viewcreditz/${music.credid}`} className="btn btn-primary btn-sm rounded-pill px-4 fw-semibold">View</Link>
                                    </td>

                                </tr>

                            ))}
                    </tbody>
                </table>
            </div>
        </>
    );
});
export default EditMusic;